module.exports = __webpack_public_path__ + "media/images/remittees_4_v3-f0f9fd97998fccdd3e4fdb8034a58f18.png";